import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, ref, watch } from 'vue';
import Message from '../base/Message.vue';
import { useWindowSize } from '@vueuse/core';

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'PostKeywords',
  props: {
    keywords: {}
  },
  setup(__props: any) {

const props = __props;

// Post keywords
const keywords = ref(props.keywords);

// Keywords container
const keywordsContainer = ref<HTMLElement>(null);

// Computed trigger
const trigger = ref(0);

// Get visible keywords
const visibleKeywords = computed(() => {
	// Trigger reactivity
	trigger.value;

	// Return all keywords if container is not available
	if (!keywordsContainer.value) return keywords.value;

    // Get container width and keyword elements
    const containerWidth = keywordsContainer.value.offsetWidth;
    const keywordElements = Array.from(keywordsContainer.value.children);

    // Calculate visible keywords
    let totalWidth = 0;
    let visibleCount = 0;

    // Calculate amount of visible keywords
    for (const el of keywordElements) {
        totalWidth += (el as HTMLElement).offsetWidth + 6;

		// Check the width with additional space for hidden keyword count
        if (totalWidth + 40 > containerWidth) break;
        visibleCount++;
    }

    // Return only visible keywords
    return keywords.value.slice(0, visibleCount);
});

// Get hidden keyword count
const hiddenKeywordCount = computed(() => keywords.value.length - visibleKeywords.value.length);

// Update hidden keywords on window resize
const { width, height } = useWindowSize();

watch([width, height], () => {
	trigger.value++;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex gap-1.5 flex-wrap",
    ref_key: "keywordsContainer",
    ref: keywordsContainer
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleKeywords.value, (keyword, i) => {
      return (_openBlock(), _createBlock(Message, {
        key: i,
        message: keyword,
        type: "neutral",
        "show-icon": false
      }, null, 8, ["message"]))
    }), 128)),
    (hiddenKeywordCount.value > 0)
      ? (_openBlock(), _createBlock(Message, {
          key: 0,
          message: `+${hiddenKeywordCount.value}`,
          type: "neutral",
          "show-icon": false
        }, null, 8, ["message"]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})